import { render, staticRenderFns } from "./PolicyDetailPage.vue?vue&type=template&id=12a81463&"
import script from "@/scripts/spentCashback/policyDetailPage.js?vue&type=script&lang=js&"
export * from "@/scripts/spentCashback/policyDetailPage.js?vue&type=script&lang=js&"
import style0 from "./PolicyDetailPage.vue?vue&type=style&index=0&id=12a81463&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports